/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-03 09:45:24
 * @LastEditors: caiqin.xie
 * @message: 配件-列表组件
 */
import React from "react";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia";
interface IList {
  id: string; // 配件id
  name: string; // 配件名称
  cover: string; // 封面
  coverAlt: string; // 封面alt
  briefIntroduction: string; // 简介
}

interface IProps {
  accessoryList: IList[]; // 配件列表
  ctry: string;
  words: Record<string, string>;
}


const AccessoryList = (props:IProps) => {
  const {ctry, words, accessoryList} = props
  return (
    <div className={styles['spare-list-wrap']}>
      {accessoryList && accessoryList.map(item => (
        <div className={styles['spare-list']} key={item.id}>
          <div className={styles['spare-img']}>
            <LazyMedia LazyClassName={styles['img-center']} type="image" src={item?.cover} alt={item?.coverAlt} />
            <a href={`/${ctry}/accessory/${item.id}`} className={styles['spare-link']}>
              <i className={styles['spare-icon']}></i>
            </a>
          </div>
          <div className={styles['spare-content']}>
            <p className={styles['spare-title']}>{item?.name}</p>
            <p className={styles['spare-desc']}>{item?.briefIntroduction}</p>
          </div>
      </div>
      ))}
    </div>
  )
}
export default AccessoryList
